var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.3333C23.3638 29.3333 29.3333 23.3638 29.3333 16C29.3333 8.63621 23.3638 2.66669 16 2.66669C8.63627 2.66669 2.66675 8.63621 2.66675 16C2.66675 23.3638 8.63627 29.3333 16 29.3333Z",
    fill: "white",
    stroke: "#D0D5DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.6667L14.6667 20L22 11.3334",
    stroke: "#2064FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPrimary);
export default __webpack_public_path__ + "static/media/CheckPrimary.ebf37b76e11422c30d982be263a329a2.svg";
export { ForwardRef as ReactComponent };